// Only activation of this button stops its decorative cue, never a scroll.
const visibleButtons = new IntersectionObserver(entries => {
  for (const {target, isIntersecting} of entries) target.classList.toggle('is-attention-visible', isIntersecting);
}, {threshold: .8});
function setupAttention() {
  document.querySelectorAll('[data-config-attention]').forEach(button => {
    if (button.dataset.attentionBound) return;
    button.dataset.attentionBound = 'true';
    visibleButtons.observe(button);
    button.addEventListener('click', () => {
      button.classList.add('has-interacted'); visibleButtons.unobserve(button);
    }, {once:true});
  });
}
setupAttention();
document.addEventListener('shopify:section:load',setupAttention);
